import { render, staticRenderFns } from "./FavoriteCard.vue?vue&type=template&id=67fb6b04&scoped=true&"
import script from "./FavoriteCard.vue?vue&type=script&lang=js&"
export * from "./FavoriteCard.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteCard.vue?vue&type=style&index=0&id=67fb6b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb6b04",
  null
  
)

export default component.exports